/** @format */
import React, {
    Context,
    FunctionComponent,
    ReactNode,
    createContext,
    useCallback,
    useState,
} from 'react';

import {
    IntercomCommand,
    IntercomContextProps,
    executeIntercomCommand,
} from '@toucan/client/global/intercom';

type IntercomProviderProps = {
    children: ReactNode;
};

export const IntercomContext: Context<IntercomContextProps> = createContext(
    {} as IntercomContextProps
);

IntercomContext.displayName = 'IntercomContext';

export const IntercomProvider: FunctionComponent<IntercomProviderProps> = ({
    children,
}) => {
    const [isEnabled, setIsEnabled] = useState(false);
    const [isLauncherVisible, setIsLauncherVisible] = useState(true);
    const [pendingCommand, setPendingCommand] = useState<
        IntercomCommand | undefined
    >();

    const openIntercom = useCallback(
        (command: IntercomCommand = { type: 'show' }) => {
            if (window.Intercom?.booted) {
                setTimeout(() => {
                    executeIntercomCommand(command);
                });
                return;
            }

            setIsEnabled(true);
            setIsLauncherVisible(true);
            setPendingCommand(command);
        },
        []
    );

    return (
        <IntercomContext.Provider
            value={{
                isEnabled,
                isLauncherVisible,
                pendingCommand,
                setIsEnabled,
                setIsLauncherVisible,
                openIntercom,
            }}
        >
            {children}
        </IntercomContext.Provider>
    );
};
